const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "GDN_PACK_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "GDN_PACK_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "GDN_PACK_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
